import { Check } from "lucide-react";

export default function DailyPay() {
  const benefits = [
    {
      title: "No more waiting",
      description: "Access your earnings 24/7 instead of monthly cycles",
    },
    {
      title: "Instant availability",
      description: "Withdraw funds as soon as they're earned",
    },
    {
      title: "Better cash flow",
      description: "Maintain steady income stream for your business",
    },
  ];

  return (
    <div className="bg-white py-20 lg:py-12 px-6 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16">
      <div className=" mx-auto max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Column - Content */}
          <div className="flex flex-col gap-[27px] items-start w-full lg:w-[728px]">
            {/* Badge */}
            <div
              className="flex items-center justify-center rounded-[100px] w-[77px] h-[50px] text-white text-[32px] font-semibold"
              style={{
                backgroundImage:
                  "linear-gradient(149.456deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)",
              }}
            >
              01
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal text-black leading-[106px] xxs:leading-tight xs:leading-tight sm:leading-tight md:leading-tight 4xl:leading-tight lg:leading-normal enfinity-header-font">
              <span className="text-[#00A656] enfinity-header-font">
                Get paid sooner
              </span>
              <span> with daily pay</span>
            </h1>

            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] max-w-[728px] enfinity-subtext-font">
              YouTube pays creators once a month. With EnfiniPay, your earnings
              are available on demand, letting you withdraw based on your
              preferred payout schedule.
            </p>

            {/* Benefits List */}
            <div className="flex flex-col gap-[30px] w-full max-w-[680px]">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#00A656] flex items-center justify-center rounded-[10px] w-[32px] h-[32px] shrink-0">
                    <Check className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>

                  {/* Content */}
                  <div className="flex flex-col gap-[10px] flex-1">
                    <h3 className="text-[24px] font-medium text-black leading-[35px] enfinity-header-font">
                      {benefit.title}
                    </h3>
                    <p className="text-[18px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-normal enfinity-subtext-font">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="w-full lg:w-[380px] flex-shrink-0">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/payout-schedule.png"
              alt="Pay Card"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
